
const constants = {
  CV_URL: 'https://www.dropbox.com/scl/fi/kl4nblulj5tarluzqzxf3/Mi-CV-Simple-EN.pdf?rlkey=aa12bu57dwjn5x26dtiv73o7s&st=8ov1114q&dl=0'
}

export default constants
